import React, { useState, useCallback } from 'react';
import Script from 'next/script';
import StickyBox from 'react-sticky-box';
import dynamic from 'next/dynamic';

const DatingAd = dynamic(() => import('components/articleDatingAd'), { ssr: false });

const Sidebar = () => {
  const [subscribed, setSubscribed] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = useCallback(async () => {
    setSubmitting(true);

    const delay = (ms) => new Promise((resolve) => {
      setTimeout(resolve, ms);
    });

    await delay(1500);

    setSubmitting(false);
    setSubscribed(true);
  }, []);

  return (
    <div className="col-12 col-lg-4 px-3">
      <StickyBox offsetTop={80} offsetBottom={20}>
        <div className="text-center bg-light sidebar-top-banner">
          <Script id="sidebar-banner">
            {`
              atOptions = {
                key: 'c92db39bd291abb16a2bb4cc6e3fbade',
                format: 'iframe',
                height: 250,
                width: 300,
                params: {},
              }
            `}
          </Script>
          <Script src="//www.highperformancedisplayformat.com/c92db39bd291abb16a2bb4cc6e3fbade/invoke.js" />
        </div>
        <div className="bg-light p-20 mt-4">
          <h2 className="mb-3 h4 font-weight-bold">
            <span className="underline">Subscribe</span>
          </h2>
          <p>
            Sign up to our newsletter and get the latest{' '}
            <b className="text-theme-color">leaked photos and videos</b>.
          </p>
          <iframe
            title="hidden_iframe"
            id="hidden_iframe"
            name="hidden_iframe"
            style={{ display: 'none' }}
          />

          <form
            action="https://docs.google.com/forms/d/e/1FAIpQLSfDLOc86zVFd9nVsRQmlnMW44jrv8wM4cxNFsLRdCxuhGLmig/formResponse"
            method="POST"
            target="hidden_iframe"
            acceptCharset="utf-8"
            onSubmit={handleSubmit}
          >
            {subscribed ? (
              <div className="form-group py-2 text-center">
                <b className="text-uppercase font-weight-bold h5 text-theme-color">Success!</b>
              </div>
            ) : (
              <>
                <div className="form-group">
                  <input
                    type="email"
                    className="form-control"
                    name="entry.1688022882"
                    placeholder="Email"
                    aria-describedby="emailHelp"
                    required
                  />
                  <small className="form-text text-muted">
                    We&#39;ll never share your email with anyone else.
                  </small>
                </div>
                {submitting ? (
                  <button className="btn btn-danger btn-block" type="button" disabled>
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    />{' '}
                    Submitting
                  </button>
                ) : (
                  <button type="submit" className="btn btn-danger btn-block">
                    Sign up
                  </button>
                )}
              </>
            )}
          </form>
        </div>
        <div className="mt-4 text-center">
          <DatingAd />
        </div>
      </StickyBox>
    </div>
  );
};

export default Sidebar;
